import nxModule from 'nxModule';
import _ from 'lodash';

import './risk-category-details.style.less';
import {incomeSourceTypes} from 'shared/customer-profile-commons/income-source/constants';
import systemPropertyService from 'system/systemPropertyService';
import templateUrl from './risk-category-details.template.html';
import {MAX_INT_32} from "constants/validation";

const sampleExcelFileBase64 = "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";

const sampleCsvFileBase64 = "U1VCU1RJVFVURV9WQUxVRSxTVUJfQ0FURUdPUlksUklTS19BU1NFU1NNRU5ULEFVVE9fSElHSF9SSVNLCkFmZ2hhbmlzdGFuLE5vbi1yZXNpZGVudCBGaWxpcGluby9JbmNvcnBvcmF0ZWQgb3IgUmVnaXN0ZXJlZCBvdXRzaWRlIHRoZSBQaGlsaXBwaW5lcyBub3Qgc3ViamVjdCB0byBGQVRGIGxpc3QsTk9STUFMLEZBTFNFCkFsYmFuaWEsTm9uLXJlc2lkZW50IEFsaWVuL0luY29ycG9yYXRlZCBvciBSZWdpc3RlcmVkIG91dHNpZGUgdGhlIFBoaWxpcHBpbmVzIHN1YmplY3QgdG8gRkFURiBsaXN0LEhJR0gsVFJVRQo=";

const SUBSTITUTED_VALUE_EXAMPLE_EXCEL_FILE = new Blob([Uint8Array.from(atob(sampleExcelFileBase64), c => c.charCodeAt(0))],
  { type: 'data;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64' });

const SUBSTITUTED_VALUE_EXAMPLE_CSV_FILE = new Blob([Uint8Array.from(atob(sampleCsvFileBase64), c => c.charCodeAt(0))],
  { type: 'data;text/csv;base64' });

class RiskCategoryDetailsView {
  constructor(http, $route, breadcrumbs, confirmation, $location, dict, popup, command) {
    this.http = http;
    this.$route = $route;
    this.breadcrumbs = breadcrumbs;
    this.confirmation = confirmation;
    this.$location = $location;
    this.dict = dict;
    this.popup = popup;
    this.command = command;
    this.systemPropertyService = systemPropertyService;
  }

  async downloadSampleExcelFile() {
    const sampleFileUrl = window.URL.createObjectURL(SUBSTITUTED_VALUE_EXAMPLE_EXCEL_FILE);
    const a = document.createElement('a');
    a.href = sampleFileUrl;
    a.download = "example_substituted_value.xlsx";
    a.click();
  }

  async downloadSampleCsvFile() {
    const sampleFileUrl = window.URL.createObjectURL(SUBSTITUTED_VALUE_EXAMPLE_CSV_FILE);
    const a = document.createElement('a');
    a.href = sampleFileUrl;
    a.download = "example_substituted_value.csv";
    a.click();
  }

  async fetchSelectedCategory() {
    this.category = await this.http.get(`/management/risk/categories/${this.categoryId}`).toPromise();

    _.set(this.breadcrumbs, 'options.risk-category-label', (this.category || {}).name);
  }

  async $onInit() {
    this.categoryId = this.$route.current.params['riskCategoryId'];
    this.maxIntegerValue = MAX_INT_32;

    await this.initializeCategory();

    [this.properties,
      this.propertyDefinitions,
      this.watchlists,
      this.customFieldDefinitions,
      this.customFieldCategories] = await Promise.all([
        this.systemPropertyService.getPropertyDescriptors(),
        this.http.get('/management/risk/categories/property-definitions').toPromise()
            .then(pd => {
              this.unfilteredPropertyDefinitions = pd;
              if ('LINKED_CONDITIONS' === this.category.assignTo) {
                return pd.filter(d => 'Substituted Values' !== d.label )
              } else if ('SUBSTITUTED_VALUE' === this.category.assignTo) {
                return pd.filter(d => 'Substituted Values' === d.label)
              }
              return pd;
            }),
        this.http.get('/management/watchlist').toPromise(),
        this.http.post(`/custom-field/definitions/search`, {enabled: true}).toPromise(),
        this.http.get(`/custom-field/categories/values`).toPromise()
      ]);

    this.customFieldDefinitionCategories = this.customFieldDefinitions
      .filter(c => c.type === 'CATEGORY')
      .map(c => ({...c, label: c.name}));
    this.customFieldDefinitionTexts = this.customFieldDefinitions
      .filter(c => c.type === 'TEXT')
      .map(c => ({...c, label: c.name}));
    this.customFieldDefinitionNumbers = this.customFieldDefinitions
      .filter(c => c.type === 'NUMBER')
      .map(c => ({...c, label: c.name}));
    this.customFieldCategories = this.customFieldCategories.map(c => ({...c, label: c.value}));

    const corpoProp = _.find(this.properties, {code: 'CIF_CORPORATE_SUPPORT'});
    this.corporateCustomerEnabled = corpoProp && corpoProp.value === 'TRUE';

    this.dict.onLoadingComplete(() => {
      this.highRiskDictionaryEntryId = this.dict.getId('CUSTOMER_RISK_LEVEL', 'HIGH');
      this.riskDictionaryEntries = this.dict['CUSTOMER_RISK_LEVEL'].sort((a, b) => a.orderNo - b.orderNo);
      this.initSingleSelectOptions();
    });

    this.setAvailableCustomerTypes();
    this.assignToOption = [
      {
        value: 'NONE',
        label: 'None'
      },
      {
        value: 'SUBSTITUTED_VALUE',
        label: 'Substituted Value'
      },
      {
        value: 'LINKED_CONDITIONS',
        label: 'Linked Conditions'
      },
    ];
    this.selectionTypeOption = [
      {
        value: 'SINGLE_SELECT',
        label: 'Single select'
      },
      {
        value: 'MULTI_SELECT',
        label: 'Multi-select'
      },
    ];
  }

  async initializeCategory() {
    if (this.categoryId) {
      await this.fetchSelectedCategory();
    } else {
      this.category = {
        weightPercentage: 0,
        entries: [],
        customerTypes: ['INDIVIDUAL', 'CORPORATE'],
        assignTo: 'NONE'
      };
    }
  }

  setAvailableCustomerTypes() {
    this.availableCustomerTypes = [
      {
        value: 'INDIVIDUAL',
        label: 'Individual'
      }
    ];

    if (this.corporateCustomerEnabled) {
      this.availableCustomerTypes.push(
        {
          value: 'CORPORATE',
          label: 'Corporate'
        }
      )
    }
  }

  initSingleSelectOptions() {
    const watchlistCategories = this.watchlists.map(w => ({...w, label: w.name}));
    const incomeSource = incomeSourceTypes.map(it => ({id: it.code, label: it.description}));
    const natureOfWork = this.dict['NATURE_OF_WORK_BUSINESS'].map(it => ({id: it.description, label: it.description}));
    this.singleSelectOptions = new Map();
    this.singleSelectOptions.set('watchlistCategories', watchlistCategories);
    this.singleSelectOptions.set('incomeSource', incomeSource);
    this.singleSelectOptions.set('natureOfWork', natureOfWork);
  }

  isMainSaveDisabled() {
    return this.form.$invalid || this.form.$pristine;
  }

  getForm(index) {
    return this[`form_${index}`];
  }

  isSaveDisabled(index) {
    return this.getForm(index).$invalid || this.getForm(index).$pristine || this.getForm(index).$submitted
  }

  isAutoHighRiskDisabled(e) {
    return e.riskDictionaryEntryId !== this.highRiskDictionaryEntryId;
  }

  onRiskLevelChange(e) {
    if (this.isAutoHighRiskDisabled(e)) {
      e.autoHighRisk = false;
    }
  }

  onAssignToChange() {
    if ('LINKED_CONDITIONS' === this.category.assignTo) {
      this.propertyDefinitions = this.unfilteredPropertyDefinitions.filter(o => 'Substituted Values' !== o.label);
      this.category.selectorType = null;
    } else if ('SUBSTITUTED_VALUE' === this.category.assignTo) {
      this.propertyDefinitions = this.unfilteredPropertyDefinitions.filter(o => 'Substituted Values' === o.label);
    }
  }

  async upsertCategory(action, command) {
    const confirmation = await this.confirmation(`Do you want to ${action} following risk category?`);
    if (!confirmation) {
      return;
    }

    if (command === 'CreateRiskCategory') {
      this.category.entries = [];
    }

    const response = await this.command.execute(command, {category: this.category}).toPromise();
    if (response.approvalRequired) {
      return;
    }

    this.$location.path(`/admin/compliance/risk/categories/${response.output.id}`);
    this.$route.reload();
  }

  async uploadSubstitutedValues() {
    const confirmation = await this.confirmation(`Do you want to apply uploaded file to substituted values in sub-categories?`);
    if (!confirmation) {
      return;
    }

    const command = this.category.id ? 'UpdateRiskCategory' : 'CreateRiskCategory';
    let response = await this.command.execute(command, {category: this.category}).toPromise();
    if (response.approvalRequired) {
      return;
    }

    const fileId = this.uploadedFiles ? this.uploadedFiles[0].id : null;
    const riskCategoryId = response.output.id ? response.output.id : this.categoryId;
    response = await this.command.execute('ApplySubstitutedValues', {fileId: fileId, riskCategoryId: riskCategoryId}).toPromise();
    if (response.approvalRequired) {
      return;
    }

    this.$location.path(`/admin/compliance/risk/categories/${riskCategoryId}`);
    this.$route.reload();
  }

  goBack() {
    this.$location.path(`/admin/compliance/risk/categories/`);
  }

  addEntry() {
    this.category.entries.push({
      riskCategoryId: this.category.id,
      conditions: {},
      autoHighRisk: false
    });
  }

  async removeEntry(idx) {
    const entry = this.category.entries[idx];
    if (entry.id) {
      const confirmation = await this.confirmation('Do you want to remove this entry?');
      if (!confirmation) {
        return;
      }

      this.category.entries.splice(idx, 1);
    } else {
      this.category.entries.splice(idx, 1);
    }
  }

  async saveAllEntries() {
    if (this.category.assignTo === 'LINKED_CONDITIONS'
      && this.category.entries.some(e => JSON.stringify(e.conditions) === '{}')) {
      this.popup({
        text: `Main category is assigned to Linked Conditions, each sub-category should be assigned a Linked Condition`,
        header: 'Error'
      });
      return;
    }

    const confirmation = await this.confirmation(`Do you want to save all changes in main category and sub-categories?`);
    if (!confirmation) {
      return;
    }

    let response = await this.command.execute('UpdateRiskCategory', {category: this.category}).toPromise();
    if (response.approvalRequired) {
      return;
    }

    const categoryEntries = this.category.entries;
    this.category.entries = this.category.entries.map(e => {
      const entry = _.cloneDeep(e);
      if (this.category.assignTo === 'NONE') {
        entry.conditions = {};
      } else {
        entry.conditions = {json: JSON.stringify(e.conditions)};
      }
      return entry;
    });

    response = await this.command.execute('UpsertRiskCategoryEntries', {
      entries: this.category.entries,
      riskCategoryId: this.categoryId
    }).toPromise()
      .catch(() => this.category.entries = categoryEntries);

    if (response.approvalRequired) {
      return;
    }

    if (response.commandId) {
      this.$route.reload();
    }
  }

  addCondition(entry, propertyDefinition) {
    // first selected property is used as a key, results in having only one such property for whole condition
    if (entry.conditions[propertyDefinition.property]) return;

    entry.conditions[propertyDefinition.property] = {properties: [propertyDefinition.property]};
  }
}

nxModule.component('riskCategoryDetailsView', {
  templateUrl,
  controller: RiskCategoryDetailsView
});
